/**
 * Register the action to be performed when "redirect-search-form" is submitted
 */

// require('jsgrid')
// require('jquery-ui/ui/widgets/sortable')
const RedirectsTableTemplate = require('views/partials/redirects-table.hbs')
const RedirectExistsTemplate = require('views/partials/redirect-exists.hbs')

class RedirectUI {
   static init(isAdmin) {
      $ = App.common.jQuery
      // console.log('jQuery', $, jQuery, $().jquery, jQuery().jquery, $ === jQuery)
      RedirectUI.isAdmin = isAdmin
      RedirectUI.init_form_submit()
      RedirectUI.init_default_redirect_autocomplete()
   }

   static init_search_submit(){
      $('#redirect-search-form').submit(function(e) {
         e.preventDefault();
         var keywords = $(this).find('input[name="keywords"]').val()

         $('#redirect-searching').show()
         $('#redirect-not-searching').hide()
         $('#redirect-search-error').hide()

         $.ajax(BaseURL+'/admin/api/search/',
            {
               data: {keywords: keywords},
               method: 'POST',
               success: function (data) {
                  $('#redirect-searching').hide()
                  $('#redirect-not-searching').show()
                  $('#redirect-keywords').text(keywords)
                  if (data.results>0) {
                     $('#redirect-found').show()
                     $('#redirect-not-found').hide()
                     $('#redirect-found tbody').replaceWith(App.main.Redirect.render_server_table(data.records))
                     $('#total-redirect').text(data.records.length);
                  }
                  else {
                     $('#redirect-found').hide()
                     $('#redirect-not-found').show()
                     $('#total-redirect').text(0);
                  }
                  $('#redirect-search-results').show()
               },
               error: function (jqXHR, status, err) {
                  if (status == 'abort')
                     return
                  $('#redirect-searching').hide()
                  $('#redirect-not-searching').show()
                  $('#redirect-search-error').show()
               }
            })
      })
   }

   /**
    * This function renders redirects grid
    * @param redirects
    * @returns {jQuery|HTMLElement}
    */
   static render_server_table(redirects) {
      return RedirectsTableTemplate({'base-url': BaseURL, redirects, isAdmin:RedirectUI.isAdmin})
   }

   /**
    * Function to redirect user to the Edit page for a particular redirect.
    * @param redirectId id of the redirect from Server_Alias.AliasID field
    */
   static goToEditPage(redirectId){
      window.location.href = BaseURL+'/admin/'+redirectId;
   }

   /**
    * Function to redirect user to the Delete page for a particular redirect.
    * @param redirectId id of the redirect from Server_Alias.AliasID field
    */
   static goToDeletePage(redirectId){
      window.location.href = BaseURL+'/admin/'+redirectId+'/disable/';
   }

   /**
    * Function that initiates drap-n-drop sortable Rules widget
    */
   static create_sortable_list(){
      var sortable_rules = $("#sortable-rules").kendoSortable({
         handler: ".handler",
         ignore: 'input',
         hint: function(element) {
            var e =  element.clone();
            e.addClass("hint");
            return e;
         },
         placeholder: function(element) {
            return element.clone().addClass("placeholder");
         }
      }).data("kendoSortable");
   }

   /**
    * This function show the "Rules" widget and adds set of widgets to enter 'Rule' information
    */
   static showAndAddRule(){
      $('ul#sortable-rules').show();
      App.main.Redirect.addNewRule();
   }

   /**
    * This function appends widgets required to add 'Rule' to the 'Rule Editor'
    */
   static addNewRule(){
      $('ul#sortable-rules').append('' +
         '<li class="list">'+
         ' <span class="handler">&nbsp;</span>'+
         ' <input type="text" style="width:35%" class="left form-control" name="match_rule" placeholder="Redirect Rule" value="" autofocus="autofocus" required />'+
         ' <input type="text" style="width:52%" class="left form-control" name="rule_translation" placeholder="Translation String" value="" autofocus="autofocus" required />'+
         ' <a class="icons btn btn-primary" title="Delete" onclick=" App.main.Redirect.deleteRule(this)"><i class="fa fa-times" aria-hidden="true"></i></a>'+
         '</li>'
      );
      $("html,body").animate({scrollTop: $('ul#sortable-rules li:last').offset().top+30});
   }

   /**
    * Function to remove <li> element from the given UL. Used by "Drag-n-drop rules" widget
    * @param el object of the 'Delete' icon
    */
   static deleteRule(el){
      $(el).closest('li').remove();
   }

   /**
    * Function that initialises action to be performed when 'save-redirect' form is submitted. Used by 'Add' & 'Edit'
    * redirect pages.
    */
   static init_form_submit() {
      $('#field-domain-name').on('change', function(e) {
         // Check if domain name already used
         let input_field = $(this)
         let domain_name = input_field.val()
         let this_id = $('#save-redirect input[name="id"]').val()

         $.ajax({
            url: BaseURL+'/admin/api/find-by-name',
            data: JSON.stringify({domain_name}),
            type: 'POST',
            // dataType: 'json',
            contentType: "application/json",
            success: function (redirect) {
               // console.log(this_id, redirect)
               input_field.siblings('.alert').remove()
               if (redirect && redirect.id && redirect.id != this_id) {
                  input_field.parent().append(RedirectExistsTemplate({redirect, BaseURL}))
               }
               // $("input[name=id]").val(data.id);
               // App.main.Helper.show_dialog(data.title,data.msg, ()=>{App.main.Redirect.goToEditPage(data.id);});
            },
            error: function (jqXHR, status, err) {
               if (status == 'abort') return
               let data = jqXHR.responseJSON || {title: 'Error', msg: err}
               if (data.msg) App.main.Helper.show_dialog(data.title,data.msg);
            }
         })
      })

      $('#save-redirect').validator().on('submit', function(e) {
         if (!e.isDefaultPrevented()) {
            e.preventDefault();

            let data = $('#save-redirect').serializeObject()
            data.path_rules = RedirectUI.get_rules()
            console.log('Saving', data)

            $.ajax({
               url: BaseURL+'/admin/api/redirect/',
               data: JSON.stringify(data),
               type: 'POST',
               // dataType: 'json',
               contentType: "application/json",
               success: function (data) {
                  $("input[name=id]").val(data.id);
                  App.main.Helper.show_dialog(data.title,data.msg, ()=>{App.main.Redirect.goToEditPage(data.id);});
               },
               error: function (jqXHR, status, err) {
                  if (status == 'abort') return
                  let data = jqXHR.responseJSON || {title: 'Error', msg: err}
                  if (data.msg) App.main.Helper.show_dialog(data.title,data.msg);
               }
            })
         }
      });
   }

   /**
    * Function that reads the rules from 'sortable-rules' widget and returns json data of the rules
    * @returns {Array}
    */
   static get_rules(){
      var $gridData = $("#jsGrid .jsgrid-grid-body tbody");
      var priority = 1;
      var items = $.map($gridData.find("tr"), function(row) {
         var item = $(row).data("JSGridItem");
         if(item) item.priority = priority++;
         return item;
      });
      console.log('Get Rules', items)
      return items;
   }

   /**
    * Function that initialises 'Autocomplete/Lookup' feature on 'Default Redirect' widget on 'Add' & 'Edit' pages
    */
   static init_default_redirect_autocomplete(){
      $("input[name='default_redirect']").kendoAutoComplete({
         dataTextField: "name",
         dataValueField: "id",
         filter: "contains",
         autoBind : true,
         autoWidth: true,
         minLength: 0,
         dataSource: {
            transport: {
               read: {
                  url: BaseURL + '/admin/api/defaults/',
                  dataType: "json",
                  type: "GET"
               }
            },
            schema: {
               data: "records",
               errors: "errors",
               total: function (data) { return data.results.length; },
               model: {
                  id: "id",
                  fields: { id:  {type: "number"},  name:  {type: "string"} }
               }
            },
            error: function (e) {
               if (e.errors) App.main.Helper.show_dialog("Error", e.errors);
            }
         }
      });
   }

   /**
    * This function disables the redirect in the database via ajax call
    * @param redirectId
    */
   static disableRedirect(redirectId){
      $.ajax(BaseURL+'/admin/api/redirect/'+redirectId, {
         method: 'DELETE',
         success: function (data) {
            App.main.Helper.show_dialog(data.title,data.msg, ()=>{App.main.Redirect.goToDeletePage(redirectId)});
            // $("a[name='delete-redirect']").hide();
            // $("button[name='back-to-search']").text("<< Back to Search")

         },
         error: function (jqXHR, status, err) {
            if (status == 'abort') return
            let data = jqXHR.responseJSON || {title: 'Error', msg: err}
            if (data.msg) App.main.Helper.show_dialog(data.title,data.msg);
         }
      })
   }

   static insertTemplate(value) {
      // console.log('Insert', arguments, this)
      this.insertControl = $("<input>").val(value);
      this.insertControl.on("keydown", function(e) {
         if(e.keyCode === 13) {
            $("#jsGrid").jsGrid("insertItem");
            $("#jsGrid").jsGrid("clearInsert");
            return false;
         }
      });
      return this.insertControl;
   }

   static editTemplate(value) {
      // console.log('Edit', arguments, this)
      this.editControl = $("<input>").val(value);
      this.editControl.on("keydown", function(e) {
         if(e.keyCode === 13) {
            $("#jsGrid").jsGrid("updateItem");
            return false;
         }
      });
      return this.editControl;
   }

   static initPathRulesGrid(redirectId){
      if (!redirectId) {
         return RedirectUI.initJsGrid([])
      }

      $.ajax(BaseURL+'/admin/api/redirect/'+redirectId, {
         method: 'GET',
         success: function (data) {
            // console.log('Init Data', data)
            RedirectUI.initJsGrid(data.path_rules)
         },
         error: function (jqXHR, status, err) {
            if (status == 'abort') return
            let data = jqXHR.responseJSON || {title: 'Error', msg: err}
            if (data.msg) App.main.Helper.show_dialog(data.title,data.msg);
         }
      })
   }

   static initJsGrid(data) {
      $("#jsGrid").jsGrid({
         width: "100%",
         height: "auto",
         inserting: true,
         editing: true,
         sorting: false,
         paging: false,
         data: data,
         confirmDeleting: true,
         deleteConfirm: "Are you sure that you want to delete this redirect rule?\n(Delete will not be committed until 'Save Redirect Details' is selected.)",
         rowClass: function(item, itemIndex) {
            return "client-" + itemIndex;
         },
         fields: [
            { name: "path_match",title: "Path Match", type: "text", width: 100, validate: "required", editTemplate: RedirectUI.editTemplate, insertTemplate:RedirectUI.insertTemplate },
            { name: "target_url", title: "Target URL", type: "text", width: 150, editTemplate: RedirectUI.editTemplate, insertTemplate:RedirectUI.insertTemplate },
            // { name: "path_id", type: "number", visible: true},
            { name: "priority", type: "number", visible: false},
            { name: "active", type: "number", visible: false},
            { type: "control",
               itemTemplate: function(value, item) {
                  let grid = this._grid
                  // console.log('Control Template', this, value, item)
                  let deleteButton = $('<a class="jsgrid-button jsgrid-button-delete"><span class="fal fa-trash fa-2x"></span></a>')
                  deleteButton.on('click', function() { grid.deleteItem(item); return false })
                  return deleteButton
               }
             }
         ],
         onRefreshed: function() {
            var $gridData = $("#jsGrid .jsgrid-grid-body tbody");
            $gridData.sortable()
         },
         insertTemplate: function() {
            // console.log('Insert', arguments)
            this.insertControl = $("<input>");
            // insert_on_enter(this.insertControl);
            return this.insertControl;
         },
         editTemplate: function(value) {

         }
      })
   }

}

module.exports = RedirectUI
